import { render } from "./Outcome.vue?vue&type=template&id=2315a4ee&ts=true"
import script from "./Outcome.vue?vue&type=script&lang=ts"
export * from "./Outcome.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__